import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { AlexxisTitle } from "../AlexxisTitle";
import { ExampleList } from "../Example";
import styles from "./ChatWelcome.module.css";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";

type ChatWelcomeProps = {
    onExampleClicked: (example: string) => void;
};

function ChatWelcome({ onExampleClicked }: ChatWelcomeProps) {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "chat" });
    const min640 = useMediaQuery("(min-width:640px)");

    return (
        <div className={styles.chatMessageStream}>
            <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                <AlexxisTitle />
            </motion.div>
            <Box className={styles.chatEmptyState}>
                <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                    <Typography
                        variant="h1"
                        className={styles.chatTitle}
                        sx={{
                            color: theme.palette.chatEmptyStateTitle,
                            fontSize: min640 ? "2.5rem" : "1.5rem",
                            fontWeight: "600",
                            userSelect: "none",
                            pointer: "default"
                        }}
                    >
                        {t("greeting")}
                    </Typography>
                </motion.div>
                <Box className={styles.exampleListContainer} sx={{ minHeight: "100px" }}>
                    <ExampleList onExampleClicked={onExampleClicked} />
                </Box>
            </Box>
        </div>
    );
}

export default ChatWelcome;
